import React from "react";
import { Button } from "react-bootstrap";

const RetakeQuizButton = ({ canRetake, remainingAttempts, onRetake }) => {
  if (!canRetake) return null;

  return (
    <div className="d-flex justify-content-center mt-3">
      <Button variant="outline-primary" className="px-4 py-2 fw-bold" onClick={onRetake}>
        Retake Quiz ({remainingAttempts} attempt{remainingAttempts === 1 ? "" : "s"} left)
      </Button>
    </div>
  );
};

export default RetakeQuizButton;
